/* Noveloshop — Fashion Nova style */
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  if (toggle) {
    toggle.addEventListener('click', function () {
      document.body.classList.toggle('nav-open');
    });
  }

  /* Gallery thumbnail swap */
  var main = document.getElementById('GalleryMain');
  if (main) {
    document.querySelectorAll('.gallery__thumbs .thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-full');
        document.querySelectorAll('.gallery__thumbs .thumb').forEach(function (x) {
          x.classList.remove('is-active');
        });
        t.classList.add('is-active');
      });
    });
  }

  /* Variant selection as buttons */
  var form = document.getElementById('ProductForm');
  var dataEl = document.getElementById('VariantData');
  if (form && dataEl) {
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var idInput = document.getElementById('VariantId');
    var priceEl = document.getElementById('ProductPrice');
    var addBtn = document.getElementById('AddBtn');
    var groups = form.querySelectorAll('.variant-group');

    function money(cents) {
      try {
        return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
      } catch (e) {
        return (cents / 100).toFixed(2) + ' €';
      }
    }
    function selected() {
      var opts = [];
      groups.forEach(function (g) {
        var active = g.querySelector('.variant-btn.is-active');
        opts.push(active ? active.getAttribute('data-value') : null);
      });
      return opts;
    }
    function update() {
      var opts = selected();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v['option' + (j + 1)] !== opts[j]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }
      if (match && idInput) {
        idInput.value = match.id;
        var now = priceEl ? priceEl.querySelector('.price-now') : null;
        if (now) now.textContent = money(match.price);
        if (addBtn) {
          if (match.available) { addBtn.disabled = false; addBtn.textContent = 'Ajouter au panier'; }
          else { addBtn.disabled = true; addBtn.textContent = 'Épuisé'; }
        }
      }
    }
    form.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.variant-group');
        group.querySelectorAll('.variant-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        update();
      });
    });
    update();
  }
})();
